import PropTypes from 'prop-types';
import * as ALOOMA from 'consts/alooma';
import Modal from 'components/templates/Modal/Modal';
import ModalBodyKarmaEarnGameGenres from 'components/molecules/ModalBodyKarmaEarnGameGenres/ModalBodyKarmaEarnGameGenres';

const ModalKarmaEarnGameGenres = props => {
  const { closeModal, sourcePage } = props;

  return (
    <Modal
      source={sourcePage}
      aloomaModalType={ALOOMA.MODAL_TYPES.POPUP}
      aloomaModalName={ALOOMA.MODAL_NAMES.KARMA_EARN_GAME_GENRES}
      onClose={closeModal}
      sendPageView={false}
    >
      <ModalBodyKarmaEarnGameGenres {...props} />
    </Modal>
  );
};

ModalKarmaEarnGameGenres.propTypes = {
  closeModal: PropTypes.func.isRequired,
  sourcePage: PropTypes.string.isRequired,
};

export default ModalKarmaEarnGameGenres;
